import { render, staticRenderFns } from "./RenovateStock.vue?vue&type=template&id=6d776f3c&scoped=true&"
import script from "./RenovateStock.vue?vue&type=script&lang=js&"
export * from "./RenovateStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d776f3c",
  null
  
)

export default component.exports